import { useGoogleMap } from "@react-google-maps/api";
import { useRef, useEffect } from "react";

const MapControl = ({ position, children }) => {
    const map = useGoogleMap();
    const ref = useRef();
    useEffect(() => {
        if (map && ref) {
          map.controls[position].push(ref.current);
        }
    }, [map, ref, position]);
    return <div ref={ref}>{children}</div>;
};

export default MapControl;
